import { ModalComponent } from './components/modal/modal.component';
import { MDBSpinningPreloader, MDBBootstrapModulesPro, ToastModule } from 'ng-uikit-pro-standard';
import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CascadingPanelComponent } from './components/cascading-panel/cascading-panel.component';
import { CascadingCardComponent } from './components/cascading-card/cascading-card.component';
import { OverlayCardComponent } from './components/overlay-card/overlay-card.component';
import { PanelComponent } from './components/panel/panel.component';
// test
import { NumericoPipe } from './pipes/numerico.pipe';
import { ModalConfirmComponent } from './components/modal-confirm/modal-confirm.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { MontoDirective } from './directivas/monto.directive';
import { OnlyNumbersDirective } from './directivas/only-numbers.directive';
import { FechaPipe } from './pipes/fecha.pipe';
import { NoDataAlertComponent } from './components/no-data-alert/no-data-alert.component';
import { RequiredFieldComponent } from './components/required-field/required-field.component';
import { ApiButtonComponent } from './components/api-button/api-button.component';
import { ApiButton2Component } from './components/api-button2/api-button2.component';
import { DecimalesDirective } from './directivas/decimales.directive';
import { ModalInfoComponent } from './components/modal-info/modal-info.component';
import { ModalOpcionesAsignacionComponent } from './components/modal-opciones-asignacion/modal-opciones-asignacion.component';
import { DiaPipe } from './pipes/dia.pipe';
import { MesPipe } from './pipes/mes.pipe';
import { NumeroPipe } from './pipes/numero.pipe';
import { TruncateNumbersPipe } from './pipes/truncate-numbers.pipe';
import { NumericInputComponent } from './components/numeric-input/numeric-input.component';
import { TmMarkIfTruncatedDirective } from './directivas/tm-mark-if-truncated.directive';
@NgModule({
  imports: [CommonModule, FormsModule, MDBBootstrapModulesPro.forRoot()],
  declarations: [
    CascadingPanelComponent,
    CascadingCardComponent,
    OverlayCardComponent,
    PanelComponent,
    ModalComponent,
    PaginationComponent,
    MontoDirective,
    OnlyNumbersDirective,
    NumericoPipe,
    NumeroPipe,
    ModalConfirmComponent,
    FechaPipe,
    NoDataAlertComponent,
    RequiredFieldComponent,
    ApiButtonComponent,
    DecimalesDirective,
    ModalInfoComponent,
    ModalOpcionesAsignacionComponent,
    ApiButton2Component,
    DiaPipe,
    MesPipe,
    TruncateNumbersPipe,
    NumericInputComponent,
    TmMarkIfTruncatedDirective,
  ],
  exports: [
    MDBBootstrapModulesPro,
    FormsModule,
    CascadingPanelComponent,
    CascadingCardComponent,
    OverlayCardComponent,
    PanelComponent,
    ModalComponent,
    PaginationComponent,
    MontoDirective,
    OnlyNumbersDirective,
    NumericoPipe,
    NumeroPipe,
    ModalConfirmComponent,
    FechaPipe,
    DiaPipe,
    MesPipe,
    TruncateNumbersPipe,
    NoDataAlertComponent,
    RequiredFieldComponent,
    ApiButtonComponent,
    DecimalesDirective,
    ModalInfoComponent,
    ModalOpcionesAsignacionComponent,
    ApiButton2Component,
    NumericInputComponent,
    TmMarkIfTruncatedDirective,
  ],
  providers: [],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule { }
